import { Box } from "@chakra-ui/react";
import { AttendanceKanbanContextProvider } from "components/atendimentos-components/kanban-and-table-atendimento/kanban/kanban-context";
import { GetLayout } from "components/get-layout";
import { useEffect, useRef, useState } from "react";
import { KanbanAndTableAtendimento } from "components/atendimentos-components/kanban-and-table-atendimento";
import { Navbar3cplusTemplate } from "components/atendimentos-components/navbar-3cplus-template";
import { PageSelect } from "components/atendimentos-components/page-select-tab";
import { use3cPlusContext } from "contexts/Context3cPlus";
import { useApplicationContext } from "contexts/ApplicationContext";
import { AbaPropostas } from "components/atendimentos-components/aba-oportunidades-esteira-nova";
import { AbaDashboardVendeAI } from "components/atendimentos-components/aba-dashboard-vende-ai";
import { useVendeAi } from "utils/active-vende-ai";

export function AtendimentoNovoKanban() {
  const [currentPage, setCurrentPage] = useState("Atendimento");
  const pageContainerRef = useRef<HTMLDivElement>(null);
  const { controls3cPlus } = use3cPlusContext();
  const { setMenuErrorMessage } = useApplicationContext();
  const vendeAiData = useVendeAi();

  useEffect(() => {
    if (!controls3cPlus.inCall) {
      setMenuErrorMessage(undefined);
    }
  }, [controls3cPlus.inCall]);

  return (
    <GetLayout
      HeadRender={Navbar3cplusTemplate}
      pageContentProps={{ p: `0px`, overflow: "overlay" }}
    >
      <AttendanceKanbanContextProvider>
        <PageSelect
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          vendeAiData={vendeAiData}
        />
        <Box w="100%" ref={pageContainerRef}>
          {currentPage === "Atendimento" ? (
            <KanbanAndTableAtendimento />
          ) : currentPage === "Propostas" ? (
            <AbaPropostas />
          ) : currentPage === "Dashboard VendeAI" ? (
            <AbaDashboardVendeAI vendeAiData={vendeAiData} />
          ) : null}
        </Box>
      </AttendanceKanbanContextProvider>
    </GetLayout>
  );
}
